var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"pre",class:[_vm.isEmoji(_vm.linkifiedComment) ? 'singe-emoji' : ''],domProps:{"innerHTML":_vm._s(_vm.linkifiedComment)}})
}
var staticRenderFns = []

export { render, staticRenderFns }